import { Component, OnInit, Input, Output, EventEmitter, computed } from '@angular/core';
import { BaseComponentDirective } from '../base/base.component';
import { UntypedFormGroup } from '@angular/forms';
import { TimerHelper } from '../helpers/timer-helper';
import { TimeSpan } from '../user-input/user-input.component';
import { PathFinderService } from '../services/path-finder.service';
import { take, tap } from 'rxjs';
import { BuyerService } from '../services/buyer.service';

@Component({
  selector: 'app-congratulations',
  templateUrl: './congratulations.component.html',
  styleUrls: ['./congratulations.component.scss']
})
export class CongratulationsComponent extends BaseComponentDirective implements OnInit {
  constructor(private pathFinder: PathFinderService, private buyerService: BuyerService) {
    super();
  }
  @Input() quoteStateId: number;
  @Input() group: UntypedFormGroup;
  @Input() purchaseTimerEndTime: Date;
  @Input() purchaseTimerStartTime: Date;
  @Input() quoteGuid: string;
  @Input() ratingUrl: string;
  @Output() stateReturn = new EventEmitter<string>();

  loading: boolean;
  purchaseTime: TimeSpan;

  qrData = computed(() => {
    const site = this.buyerService.getCurrentSiteFromStorage();
    console.log(`${this.ratingUrl}${this.quoteGuid + '?siteId=' + site.siteId}`);
    return `${this.ratingUrl}${this.quoteGuid + '?siteId=' + site.siteId}`;
  })

  ngOnInit() {
    this.loading = false;
    this.group.controls.value.setValue(true);

    if (this.purchaseTimerStartTime && this.purchaseTimerEndTime) {
      this.purchaseTime = TimerHelper.getElapsedTime(this.purchaseTimerStartTime, this.purchaseTimerEndTime);
    }

    this.pathFinder.stopPurchaseTimer.pipe(
      tap(stopDate => {
        this.purchaseTime = TimerHelper.getElapsedTime(this.purchaseTimerStartTime, new Date(stopDate));
      }),
      take(1)).subscribe();
  }
}
